import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a33e675c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a33e675c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33e675c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33e675c')) {
      api.createRecord('a33e675c', component.options)
    } else {
      api.reload('a33e675c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a33e675c&scoped=true&", function () {
      api.rerender('a33e675c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9AB1gbL4Rz7/JS/comp/SearchFilterTokens.vue"
export default component.exports